import { render, staticRenderFns } from "./PersonManage.vue?vue&type=template&id=0393ebb6"
import script from "./PersonManage.vue?vue&type=script&lang=js"
export * from "./PersonManage.vue?vue&type=script&lang=js"
import style0 from "./PersonManage.vue?vue&type=style&index=0&id=0393ebb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports